import { Injectable } from '@angular/core';
import { IBroadcastEvent } from '../../interfaces/ibroadcast-event';
import { Subject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class BroadcasterService {
    private _eventBus: Subject<IBroadcastEvent> = new Subject<IBroadcastEvent>();
    private _id: any;

    constructor() {
        this._eventBus = new Subject<IBroadcastEvent>();
        this._id = new Date().getTime();
    }

    broadcast(key: any, data?: any) {
        this._eventBus.next({ key, data });
    }

    on<T>(key: any): Observable<T> {
        return this._eventBus.pipe(
            filter((event: any) => event.key === key),
            map((event: any) => <T>event.data)
        );
    }
}
